import * as React from 'react';
import { css } from 'aphrodite';

import * as autoForm from 'login-utils/autoForm';
import * as autoLoanUtils from 'login-utils/autoLoanUtils';
import AutoCashOutRefinanceSVG from 'login-components/Common/svg/AutoCashOutRefinanceSVG';
import AutoStandardRefinanceSVG from 'login-components/Common/svg/AutoStandardRefinanceSVG';
import { DataShape, Field, FormProps, reduxForm } from 'redux-form';
import ErrorMessage from 'login-components/Common/Notifications/ErrorMessage/ErrorMessage';
import { connect } from 'react-redux';
import history from 'login-utils/history';
import LargeIconButtonGroup from 'login-components/Common/LargeIconButtonGroup/LargeIconButtonGroup';
import { LargeIconButtonConfig } from 'login-components/Common/Buttons/LargeIconButton';
import LoadingSpinner from 'login-components/Common/LoadingSpinner/LoadingSpinner';
import { paneFormStyles } from 'login-components/Common/PaneLayout/paneStyles';
import States from 'login-constants/states';

const autoRefinanceTypeConfigs: LargeIconButtonConfig[] = [
  {
    value: 'LOAN',
    iconComponent: AutoStandardRefinanceSVG,
    buttonId: 'it-chooseAutoRefinanceTypeLoan',
    text: 'Standard refinance',
    subText: 'Lower your monthly payment or change your loan term.',
  },
  {
    value: 'CASH_OUT',
    iconComponent: AutoCashOutRefinanceSVG,
    buttonId: 'it-chooseAutoRefinanceTypeEquity',
    text: 'Cash-out refinance',
    subText: 'Use your car’s value to get cash for expenses.',
  },
];

// if the user lands on this page and somehow hasn't set fields,
// we can assume a REFINANCE
const initialValues: DataShape = {
  autoLoanPurposeType: 'REFINANCE',
  autoRefinanceType: null,
};

export type ChooseAutoRefinanceTypeProps = ReactRouter.RouteComponentProps<{}, {}>;

interface ChooseAutoLoanRefinanceTypeState {
  isSubmitting: boolean;
  error: string;
}

export class ChooseAutoRefinanceType extends React.Component<
  ChooseAutoRefinanceTypeProps & FormProps<DataShape, ChooseAutoRefinanceTypeProps, ReduxState>,
  ChooseAutoLoanRefinanceTypeState
> {
  state = {
    isSubmitting: false,
    error: '',
  };

  onSelect = async value => {
    if (autoLoanUtils.shouldCreateOrUpdateAutoLoan()) {
      this.setState({
        error: '',
        isSubmitting: true,
      });
      try {
        await autoLoanUtils.createOrUpdateAutoLoan({
          autoLoanPurposeType: 'REFINANCE',
          autoRefinanceType: value,
        });
      } catch (err) {
        this.setState({
          error: 'Failed to create application, please try again',
          // Only unset on error, since we navigate away in the success case
          // and don't want the user to be able to submit again
          isSubmitting: false,
        });
      }
    } else {
      history.push(States.CREATE_ACCOUNT);
    }
  };

  render() {
    const { error, isSubmitting } = this.state;
    return (
      <div>
        {isSubmitting ? (
          <div className={css(paneFormStyles.loadingSpinnerWrapper)}>
            <LoadingSpinner />
          </div>
        ) : (
          <React.Fragment>
            {error && (
              <div className={css(paneFormStyles.errorWrapper)}>
                <ErrorMessage errorText={error} />
              </div>
            )}
            <Field
              name={autoForm.FIELDS.autoRefinanceType}
              configs={autoRefinanceTypeConfigs}
              onSelect={this.onSelect}
              component={LargeIconButtonGroup}
            />
          </React.Fragment>
        )}
      </div>
    );
  }
}

const withReduxForm = reduxForm<
  FormProps<DataShape, ChooseAutoRefinanceTypeProps, ReduxState>,
  ChooseAutoRefinanceTypeProps,
  ReduxState
>({
  initialValues,
  ...autoForm.FORM_CONFIG,
})(ChooseAutoRefinanceType);

export default connect<{}, {}, ChooseAutoRefinanceTypeProps>(
  null,
  {},
)(withReduxForm);
